module.exports = __webpack_public_path__ + "img/loading.e137e665.gif";